export default __webpack_public_path__ + "static/media/Ravan.37846f2e.png";